import MaterialTable from 'material-table';
import React, { useEffect, useState } from 'react';
import tableIcons from '../templates/TableIcons';
import getColumns from './UserColumns';
import Edit from "@material-ui/icons/Edit";
import { withRouter } from "react-router";
import { deleteUser, getUser } from "../../repo/userRepo";
/*
Documentation on developing the Material-Table can be found at https://material-table.com/
You can use the async function passed to MaterialTable data prop to implement filters and sorting on server-side
Filters and sorting can't be implemented on client side due to server-side pagination.
*/

const UserTable = (props) => {
    const history = props.history;
    const [columns, setColumns] = useState(getColumns({}));
    const tableRef = React.createRef();

    //Here we call delete
    const handleRowDelete = (oldData, resolve) => {
        deleteUser(oldData.id)
            .then(res => {
                resolve()
            })
            .catch(error => {
                resolve()
            })
    }

    useEffect(() => {
        tableRef.current.onQueryChange();
    }, [props.role]);

    return (
        <div>
            <MaterialTable
                tableRef={tableRef}
                minRows={10}
                title="Data Pengguna Sistem"
                columns={columns}
                data={async (query) => {
                    const res = await getUser(props.role == 'all' ? null : props.role, query.page, query.pageSize, query.search);
                    return ({
                        data: res.records,
                        page: query.page,
                        totalCount: parseInt(res.TotalRecord)
                    })
                }
                }
                options={{
                    sorting: false,
                    actionsColumnIndex: -1,
                    pageSize: 10,
                    toolbar: true,
                    paging: true
                }}

                actions={[
                    {
                        icon: () => <Edit />,
                        tooltip: 'Edit',
                        onClick: (event, rowData) => {
                            history.push({
                                pathname: `/dashboard/user/update/${rowData.id}`,
                                user: rowData
                            })
                        }
                    },
                ]}

                icons={tableIcons}
                editable={{
                    onRowDelete: (oldData) =>
                        new Promise((resolve) => {
                            handleRowDelete(oldData, resolve)
                        }),
                }}

            />
        </div>);
}
export default withRouter(UserTable);
